<template lang='pug' src='./custom-practice-map.pug'></template>

<script>
import Contact from 'components/custom/custom-home-contact/custom-home-contact'
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  components: {
    Contact,
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// custom-practice-map.vue?8b7b68c4